'use client';

import {
  MyEquipmentHeader,
  MyEquipmentInfoToolTip
} from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import styles from '../add-equipment-drawer.module.scss';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { useFormContext } from 'react-hook-form';
import { useFeedback } from 'providers/feedback-provider';

export const AddEquipmentHeaderMobile = () => {
  const t = useTranslations();
  const {
    addEquipmentDrawer: { closeDrawer, isChild }
  } = useMyEquipmentDrawer();
  const { dismissFeedback } = useFeedback();
  const { clearErrors, reset } = useFormContext();

  const resetFormAndCloseDrawer = () => {
    dismissFeedback();
    reset();
    clearErrors();
    closeDrawer();
  };

  return (
    <MyEquipmentHeader
      variant={'title-sm'}
      className="d-flex d-md-none"
      onBackButtonClick={isChild ? resetFormAndCloseDrawer : null}
    >
      <span>{t('ADD_EQUIPMENT_DRAWER_HEADING')}</span>
      <MyEquipmentInfoToolTip
        position="bottom"
        aria-label={`${t('PLEASE_NOTE')} ${t('MEQ_SUPPORTED_EQUIP1')}`}
        className={`${styles['equipment-header-tooltip']}`}
        label={t('MEQ_SUPPORTED_EQUIP1')}
        isInteractive={true}
      >
        <span className="font-weight-bold">{t('PLEASE_NOTE')}</span>
      </MyEquipmentInfoToolTip>
    </MyEquipmentHeader>
  );
};
